import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const { theirRole, decision } = commonConfigValues

const { helpers: { keepInLength, getLoginFromMail, getUserId } } = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const consultationSubject = [
  { id: 1, label: 'Bedroom Decoration' },
  { id: 2, label: 'Bedroom Furnishings' },
  { id: 3, label: 'Centre Activities / Holidays' },
  { id: 4, label: 'Centre Decoration' },
  { id: 5, label: 'Centre Furnishings' },
  { id: 6, label: 'Centre Meal Planning' },
  { id: 7, label: 'Centre Problem Solving' },
  { id: 8, label: 'Centre Rules / Routines' },
  { id: 9, label: "Centre Young People's Meeting" },
  { id: 10, label: 'Child in Care Review Preparation' },
  { id: 11, label: 'Consultation - DCYA' },
  { id: 12, label: 'Consultation - EPIC' },
  { id: 13, label: 'Consultation - Ombudsman' },
  { id: 14, label: 'Consultation - Tusla' },
  { id: 15, label: 'HIQA Inspection' },
  { id: 16, label: 'Monitoring Visit' },
  { id: 17, label: 'Personal Interests / Activities Check-in' },
  { id: 18, label: 'Personal Needs / Wants Check-in' },
  { id: 19, label: 'Personal Wellbeing Check-in' },
  { id: 20, label: 'Other' }
]

export const evidenced = [
  { id: 1, label: '121 Session Notes' },
  { id: 2, label: 'Absence Management Plan' },
  { id: 3, label: 'Behaviour Management Plan' },
  { id: 4, label: 'Centre YP Meeting Minutes' },
  { id: 5, label: 'Child in Care Review Minutes' },
  { id: 6, label: "Child in Care Review Young Person's Consultation Form" },
  { id: 7, label: 'Conversation of Note' },
  { id: 8, label: 'Crisis Management Plan' },
  { id: 9, label: 'DCYA Report' },
  { id: 10, label: 'EPIC Report' },
  { id: 11, label: 'Evidencing Report Pending' },
  { id: 12, label: 'HIQA Inspection Report' },
  { id: 13, label: 'Key Work Session Notes' },
  { id: 14, label: 'Life Space Interview' },
  { id: 15, label: 'Monitoring report' },
  { id: 16, label: 'Ombudsman Report' },
  { id: 17, label: 'Placement Plan Session Notes' },
  { id: 18, label: 'Placement Support Plan' },
  { id: 19, label: 'Risk Management Plan' },
  { id: 20, label: 'Routine Management Plan' },
  { id: 21, label: 'Safety Plan' },
  { id: 22, label: 'Significant Event Report' },
  { id: 23, label: 'Situation Management Plan' },
  { id: 24, label: 'Tusla Report' },
  { id: 25, label: "Young Person's Daily Journal" },
  { id: 26, label: 'Other' }
]

export const valueTable = {
  consultationSubject,
  evidenced
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'person.fullName',
      'consultation.date',
      'consultation.subject',
      'consultation.carriedOut',
      'consultation.theirRole',
      'consultation.decision',
      'consultation.decisionLogged',
      'consultation.notes'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.personId',
    title: 'YP UI',
    minSpace: 'YP UIw ',
    formField: true
  },
  {
    name: 'register.person.firstName',
    title: 'YP First Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.lastName',
    title: 'YP Last Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.fullName',
    title: 'YP Name',
    formField: true,
    getCellValue: row =>
      `${row['register.person.firstName']} ${row['register.person.lastName']}`,
    maxChars: 100,
    minSpace: 'YP Name '
  },
  {
    name: 'consultation.date',
    title: 'Consultation Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Consultation '
  },
  {
    name: 'consultation.time',
    title: 'Consultation Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'Consultation '
  },
  {
    name: 'consultation.subject',
    title: 'Consultation Subject',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(consultationSubject, [
        'id',
        parseInt(row[`consultation.subject`], 10)
      ])
        ? _.find(consultationSubject, [
            'id',
            parseInt(row[`consultation.subject`], 10)
          ]).label
        : row[`consultation.subject`],
    options: 'consultationSubject',
    filterField: true,
    minSpace: 'Consultation '
  },
  {
    name: 'consultation.carriedOut',
    title: 'Consultation Carried Out By Name(s)',
    formField: true,
    maxChars: 50,
    minSpace: 'Carried Out By Names(s) '
  },
  {
    name: 'consultation.theirRole',
    title: 'Their Role(s)',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`consultation.theirRole`], 10)])
        ? _.find(theirRole, ['id', parseInt(row[`consultation.theirRole`], 10)])
            .label
        : row[`consultation.theirRole`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Role(s) '
  },
  {
    name: 'consultation.evidenced',
    title: 'Consultation Evidenced',
    formField: true,
    type: 'select',
    multiple: true,
    getCellValue: row => {
      const rowValues = row[`consultation.evidenced`]
      const value = rowValues
        .map(
          i =>
            _.find(evidenced, ['id', parseInt(i, 10)])
              ? _.find(evidenced, ['id', parseInt(i, 10)]).label
              : i
        )
        .join(',')

      // _.find(evidenced, ['id', parseInt(row[`consultation.evidenced`], 10)])
      //   ? _.find(evidenced, ['id', parseInt(row[`consultation.evidenced`], 10)])
      //       .label
      //   : row[`consultation.evidenced`]
      return value
    },
    options: 'evidenced',
    filterField: true,
    minSpace: 'Consultation '
  },
  {
    name: 'consultation.decisionMade',
    title: 'Decision(s) Made',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`consultation.decisionMade`], 10)])
        ? _.find(decision, [
            'id',
            parseInt(row[`consultation.decisionMade`], 10)
          ]).label
        : row[`consultation.decisionMade`],
    options: 'decision',
    filterField: true,
    minSpace: 'Decision(s) '
  },
  {
    name: 'consultation.decisionLogged',
    title: 'Decision(s) Logged',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`consultation.decisionLogged`], 10)])
        ? _.find(decision, [
            'id',
            parseInt(row[`consultation.decisionLogged`], 10)
          ]).label
        : row[`consultation.decisionLogged`],
    options: 'decision',
    filterField: true,
    minSpace: 'Decision(s) '
  },
  {
    name: 'consultation.notes',
    title: 'Consultation Notes ',
    formField: true,
    maxChars: 300,
    filterField: true,
    minSpace: 'Consultatnion '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'consultation',
      historyName: 'consultationHistory',
      label: 'Register',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Register Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const person = _.find(availableValues.persons, ['id', o.personId])
            const label = `${person.firstName} ${person.lastName} (register: ${
              o.id
            })`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'cns',
      activeName: 'consultation',
      historyName: 'consultationHistory',
      label: 'Consultations',
      icon: 'note',
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consultation.date',
            label: 'Consultation Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consultation.time',
            label: 'Consultation Time',
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'consultation.subject',
          label: 'Consultation Subject',
          multiple: true,
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: valueTable.consultationSubject
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'consultation.carriedOut',
            label: 'Consultation Carried Out By Name(s)',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consultation.theirRole',
            label: 'Their Role',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'consultation.evidenced',
          label: 'Consultation Evidenced',
          multiple: true,
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.evidenced.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consultation.decisionMade',
            label: 'Decision(s) Made',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consultation.decisionLogged',
            label: 'Decision(s) Logged',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'consultation.notes',
          label: 'Consultation Notes',
          normalize: v => {
            const val = keepInLength(v, 300)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['consultation']

export const errors = [1, 2]

export const defaultNew = {
  consultation: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  consultationHistory: []
}

// "consultations": [
//   {
// "consultation": {
//   "id": 1,
//   "registerId": 1, //  ->  "personId": 2 -> person,
//   "date": "2001-01-01T23:28:56.782Z",
//   "time": "T23:28:56.782Z",
//   "subject": 2,
//   "carriedOut": "daa",
//   "theirRole": 2,
//   "evidenced" : 2,
//   "decisionMade" :2,
//   "decisionLogged": 1,
//   "notes": "aaa"
// },
// "consultationHistory": {

// }
//   }
// ]



// WEBPACK FOOTER //
// ./src/register/configs/consultations.js